import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00B5AD',
    },
    info: {
      main: '#fff',
    },
  },
});

export default theme;
